<script>
  /**
   * cardlist (array)= [ ['nom',valeur], [ ]...]
   * color = orange , green
   */
  export let cardColor = "";
  export let cardTitle = "";
  export let cardPrix = "";
  export let cardLink = "#";
  export let cardList = undefined;
</script>

<div class="plan-card plan-one">
  <div class="pricing-header {cardColor}">
    <h4 class="plan-title">{cardTitle}</h4>
    <div class="plan-cost">{cardPrix}</div>
    <div class="plan-save" />
  </div>
  <div class="tabPrix" align="center">
    {#if cardList !== undefined}
            <table class="table table-bordered  ">
        {#each cardList as item}
                <tr>
                    {#each item as elmt}
                    <td>{elmt}</td>
                    {/each}
                </tr>

        {/each}
        </table>
    {/if}
</div>
  {#if cardLink !== "#"}
    <div class="plan-footer">
      <a href={cardLink} class="btn btn-danger btn-lg btn-rounded"
        >Select Plan</a
      >
    </div>
  {/if}
</div>

<style>
  .content {
    margin-top: 40px;
  }

  .tabPrix{
        font-size: 0.85em;
        padding: 3px;
  }

  .plan-one {
    margin: 0 0 20px 0;
    width: 100%;
    position: relative;
  }

  .plan-card {
    background: rgb(169, 167, 167);
    margin-bottom: 30px;
    transition: 0.5s;
    border: 1px rgba(70, 67, 67, 0.5);
    border-radius: 0.55rem;
    position: relative;
    width: 100%;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  }

  .plan-one .pricing-header {
    padding: 0;
    margin-bottom: 0;
    text-align: center;
  }

  .plan-one .pricing-header .plan-title {
    -webkit-border-radius: 10px 10px 0px 0px;
    -moz-border-radius: 10px 10px 0px 0px;
    border-radius: 10px 10px 0px 0px;
    font-size: 1.2rem;
    color: #ffffff;
    padding: 10px 0;
    font-weight: 600;
    background: #5a99ee;
    margin: 0;
  }

  .plan-one .pricing-header .plan-cost {
    color: #ffffff;
    background: #71a7f0;
    padding: 15px 0;
    font-size: 2.5rem;
    font-weight: 700;
  }

  .plan-one .pricing-header .plan-save {
    color: #ffffff;
    background: #84b3f2;
    padding: 10px 0;
    font-size: 1rem;
    font-weight: 700;
  }

  .plan-one .pricing-header.green .plan-title {
    background: #47bcc7;
  }

  .plan-one .pricing-header.green .plan-cost {
    background: #5bc3cd;
  }

  .plan-one .pricing-header.green .plan-save {
    background: #6ac9d2;
  }

  .plan-one .pricing-header.orange .plan-title {
    background: #fc8165;
  }

  .plan-one .pricing-header.orange .plan-cost {
    background: #fd967e;
  }

  .plan-one .pricing-header.orange .plan-save {
    background: #fdaa97;
  }

  .plan-one .plan-features {
    border: 1px solid #e6ecf3;
    border-top: 0;
    border-bottom: 0;
    padding: 0;
    margin: 0;
    text-align: left;
  }

  .plan-one .plan-footer {
    border: 1px solid #e6ecf3;
    border-top: 0;
    background: #ffffff;
    -webkit-border-radius: 0 0 10px 10px;
    -moz-border-radius: 0 0 10px 10px;
    border-radius: 0 0 10px 10px;
    text-align: center;
    padding: 10px 0 30px 0;
  }

  @media (max-width: 767px) {
    .plan-one .pricing-header {
      text-align: center;
    }
  }
</style>
